module.exports = {
  /* eslint-disable */
  githubSrc:
    "https://raw.githubusercontent.com/ohbm/cobidas_schema/master/schemas/pet/protocols/pet_schema.jsonld",
  banner: "This protocol is under construction.",
  startButton: "Start",
  assetsPublicPath: "/cobidas-PET/",
  backendServer: "null",
};
